import { ThemeOptions } from '@mui/material';
import { palette } from 'themeV5/palette/light';
import baseThemeOptions from './base-theme-options';

const themeOptions: ThemeOptions = {
  palette: { mode: 'light', ...palette },
  ...baseThemeOptions,
};

export default themeOptions;
